import { getWrapperMaxWidth } from '@/cms/utils';
import { SearchBar } from '@/decodo/blocks/HeroWithSearch/SearchBar';
import Heading from '@/decodo/components/atoms/Heading';
import { SECTION_NAMES } from '@/integrations/trackingScripts/constants';
import { cn } from '@/lib/utils';
import { Suspense } from 'react';
import RainbowWave from '~/svg/RainbowWave.svg';

type SearchFinalProps = {
  slug?: string;
  classNames?: {
    root?: string;
  };
  searchWithin?: 'faq';
  title: string;
  description: React.ReactNode;
  image: React.ReactNode;
  links: React.ReactNode;
};

export function HeroWithSearch({
  slug,
  searchWithin,
  image,
  links,
  title,
  description,
}: SearchFinalProps) {
  return (
    <section
      className='bg-gray-25 md:py-15 md:px-15 relative flex w-full justify-center bg-cover bg-center p-5 py-8'
      data-tracker-section={SECTION_NAMES.HERO_WITH_SEARCH}
    >
      <div className='absolute inset-0 hidden md:block'>
        <RainbowWave className='h-full w-full' />
      </div>
      <div
        className={cn(
          getWrapperMaxWidth('mid'),
          'md:bg-gray-25/50  static z-20 flex w-full items-center gap-6 md:px-5 md:py-8 md:backdrop-blur-[4px]'
        )}
      >
        <div className='flex w-full flex-1 flex-col'>
          <Heading
            level='h1'
            classNames={{
              root: 'mb-6 dark:text-base-dark-white text-gray-950',
            }}
          >
            {title}
          </Heading>
          <div className='dark:text-base-dark-white mb-9 text-gray-500'>
            {description}
          </div>
          <div
            className={cn('flex flex-wrap gap-6 pb-8 md:pb-12')}
            data-tracker-component='buttons'
          >
            {links}
          </div>
          <Suspense>
            <SearchBar slug={slug} searchWithin={searchWithin} />
          </Suspense>
        </div>
        <div className='relative hidden h-full w-full flex-1 items-center justify-center md:flex'>
          {image}
        </div>
      </div>
    </section>
  );
}
